

























































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import _ from "lodash";
import EventBus from "front-component/EventBus";
import Tag from "@/components/miscellaneous/Tag.vue";

interface SelectOption {
    key: string;
    label: string;
    hidden?: boolean;
    tag?: string;
    class?: string;
}

interface GroupedOption {
    label: string;
    options: SelectOption[];
}

@Component({ components: { Tag } })
export default class MultipleSelectSearch extends Vue {
    @Prop({ default: () => [] }) public value!: string[];
    @Prop() public filterName!: string;
    @Prop({
        type: Array,
        default: () => [],
    })
    public options!: SelectOption[] | GroupedOption[];
    @Prop() public classes!: string;
    @Prop() public placeholder!: string;
    @Prop() public clearable!: boolean;
    @Prop({ default: false }) public groupOptions!: boolean;

    private filter: string[] = [];

    private mounted() {
        this.filter = this.value;
    }

    @Watch("value")
    private onValueChange(value: string[]): void {
        if (JSON.stringify(value) !== JSON.stringify(this.filter)) {
            this.filter = value;
        }
    }

    @Watch("filter")
    private onFilterChange(value: string[]): void {
        this.$nextTick(() => {
            const elTag = this.$el.querySelector(".el-tag") as HTMLElement;
            if (elTag && elTag.textContent) {
                elTag.title = elTag.textContent;
            }
        });
        EventBus.$emit("update-filter", _.set({}, this.filterName, value));
    }
}
